'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _queryString = require('query-string');

var _queryString2 = _interopRequireDefault(_queryString);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var numberRegex = /[0-9]+/;

var LoadMore = function () {
  function LoadMore(el) {
    (0, _classCallCheck3.default)(this, LoadMore);

    this.els = {
      el: el,
      button: (0, _functional.getElement)('[data-module-load-more-button]'),
      pagination: (0, _functional.getElement)('[data-module-load-more-pagination]'),
      text: (0, _functional.getElement)('[data-module-load-more-text]'),
      target: (0, _functional.getElement)('[data-module-load-more-target]')
    };

    this.currentPage = parseInt(this.els.el.dataset.currentPage, 10);

    this.config = {
      listItemClass: this.els.el.dataset.className,
      perPage: parseInt(this.els.el.dataset.perPage, 10),
      totalItems: parseInt(this.els.el.dataset.totalItems, 10),
      url: this.els.el.dataset.url,
      parsedQuerystring: _queryString2.default.parse(window.location.search)
    };

    this._loading = false;
    this.shouldUpdateCurrentAmountViewed = this.els.text != null;

    this.handleButtonClick = this.handleButtonClick.bind(this);

    this.setupListeners();
  }

  (0, _createClass3.default)(LoadMore, [{
    key: 'setupListeners',
    value: function setupListeners() {
      if (this.els.button) {
        this.els.button.addEventListener('click', this.handleButtonClick);
      }
    }
  }, {
    key: 'handleButtonClick',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var parsedQuerystring, _ref2, data, fragment, div, newElements;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.loading = true;
                this.currentPage += 1;

                parsedQuerystring = (0, _assign2.default)({}, this.config.parsedQuerystring);

                parsedQuerystring.page = this.currentPage;

                _context.next = 6;
                return _axios2.default.get(this.config.url + '?' + _queryString2.default.stringify(parsedQuerystring));

              case 6:
                _ref2 = _context.sent;
                data = _ref2.data;


                this.loading = false;
                fragment = document.createDocumentFragment();
                div = (0, _functional.createElement)('div');

                div.innerHTML = data;

                newElements = (0, _functional.getElements)('.' + this.config.listItemClass, {
                  context: div
                });


                newElements.forEach(function (item) {
                  fragment.appendChild(item);
                });

                this.els.target.appendChild(fragment);

                this.setCurrentAmountViewed();

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleButtonClick() {
        return _ref.apply(this, arguments);
      }

      return handleButtonClick;
    }()
  }, {
    key: 'setCurrentAmountViewed',
    value: function setCurrentAmountViewed() {
      var currentTotal = (0, _functional.getElements)('.' + this.config.listItemClass + ':not(.' + this.config.listItemClass + '-advert)').length;
      if (this.shouldUpdateCurrentAmountViewed) {
        this.els.text.innerText = this.els.text.innerText.replace(numberRegex, currentTotal);
      }
      if (currentTotal === this.config.totalItems) {
        this.els.button.remove();
      }
    }
  }, {
    key: 'loading',
    get: function get() {
      return this._loading;
    },
    set: function set(val) {
      this._loading = val;

      this.els.button.setAttribute('aria-busy', String(val));
    }
  }]);
  return LoadMore;
}();

exports.default = LoadMore;